import { shipmentStatuses } from '@reveni-io/reveni-ui'

export const getPreparableParcels = parcels => {
  return parcels?.filter(
    parcel =>
      parcel.related && (parcel.status === shipmentStatuses.requested || parcel.status === shipmentStatuses.packed)
  )
}
